module.exports = __webpack_public_path__ + "img/happenings_en@2x.f1ea071a.png";